<template>
    <div  v-if="datas">
        <div class="boxShadow hot-job">
           <div class="flexBetween hot-job-title">
                <p>热招职位</p>
                <p class="hot-job-all" @click="checkAllJobs">查看全部{{ datas.positionCounts }}个职位 <i class="el-icon-caret-right"></i></p>
           </div>
        
            <div class="flex hot-job-items">
                <div v-for="item in datas.positions" :key="item.id" class="transitionStyle hot-job-items-box" @click="goToPosition(item.id)">
                    <div class="flexBetween">
                        <p class="textOver">{{ item.name }}</p>
                        <p class="shrink">{{ item.salaryRangeName }}</p>
                    </div>
                    <div class="flex" style="margin: 10px 0;">
                        <Btns :value="item.workExperienceName"></Btns>
                        <Btns :value="item.qualificationsName"></Btns>
                        <!-- <Btns :types="2"></Btns> -->
                    </div>
                    <div class="hot-job-items-bottom"> {{ item.address }}</div>
                </div>

            </div>
        </div>
        
        <div class="flexBetween main">
            <div class="main-left boxShadow ">
                <div class="company-desc">
                    <div class="main-left-title">公司简介</div>
                    <div  class="main-left-companyinfo" :class="isAll?'noHeight':''">
                        <div v-html="datas.description"></div>
                    </div>
                    <div class="expand" @click="checkAll">
                        {{isAll?'收起':'全部'}} 
                        <i :class="isAll ?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                    </div>
                </div>

                <div class="main-left-title" v-if="datas.companyAlbumInfoList && datas.companyAlbumInfoList.length>0">公司相册</div>
                <div class="main-left-companyimg" v-if="datas.companyAlbumInfoList && datas.companyAlbumInfoList.length>0">
                    <swiper :options="options" ref="mySwiper">

                        <swiper-slide v-for="item in datas.companyAlbumInfoList" :key="item.id">
                            <el-image 
                            style="margin: 0 4px;border-radius: 10px;width: 293px;height: 220px;"
                            :src="item.url" 
                            :fit="'fill'"
                            :preview-src-list="imgList"
                        >
                        </el-image>
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                    
                </div>

                <div class="main-left-title">公司地址</div>
                <p class="main-left-address">公司地址：{{datas.adressDetail}}</p>
                <el-amap
                    vid="amapDemo1"
                    :center="location"
                    :zoom="14"
                    class="amap-demo"
                >
                    <el-amap-marker
                    vid="component-marker"
                    :position="componentMarker.position"
                    ></el-amap-marker>
                    <el-amap-info-window
                    :position="componentMarker.position"
                    :offset="componentMarker.offset"
                    :content="componentMarker.content"
                    >
                    </el-amap-info-window>
                </el-amap>
                
            </div>
            <div class="main-right main-left">
                <login-tabs></login-tabs>
                <div class="boxShadow main-right-title">
                    <div class="main-left-title">工作时间及福利</div>
                    <p>{{ datas.workHoursEnd }}-{{ datas.workHoursStart }}</p>
                    <p>{{datas.workWay}}</p>
                    <Btns v-for="item in datas.welfareInfos" :key="item.id" :value="item.welfareName"></Btns>
                    <!-- <Btns></Btns>
                    <Btns></Btns>
                    <Btns></Btns>
                    <Btns></Btns>
                    <Btns></Btns> -->
                </div>
                <div class="boxShadow main-right-title">
                    <div class="main-left-title">工商信息</div>
                    <p>{{datas.nameCn}}</p>
                    <p><span>法人代表</span> {{datas.companyBusinessInfomation.legalRepresentative}}</p>
                    <p><span>注册资本</span> {{datas.companyBusinessInfomation.registeredCapital}}</p>
                    <p><span>企业类型</span> {{datas.companyBusinessInfomation.enterpriseType}}</p>
                    <p><span>经营状态</span> {{datas.companyBusinessInfomation.businessStatus}}</p>
                    <p><span>成立时间</span> {{datas.companyBusinessInfomation.registrationTime}}</p>
                </div>

            
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import { swiper, swiperSlide} from 'vue-awesome-swiper';
  import { AMapManager } from "vue-amap";
 import Btns from '../../../components/Btn.vue';
 import LoginTabs from '../../../components/loginTab.vue';
 import 'swiper/dist/css/swiper.css'
  export default {
    props: {
        datas:{
            type:Object,
            default:()=>{}
        },
        componentMarker:{
            type:Object,
            default:()=>{}
        },
        location:{
            type:Array,
            default:()=>{}
        },
        imgList:{
            type:Array,
            default:()=>{}
        }
    },
    data() {
      return {
        amapManager: new AMapManager(),
        isAll:false,
        options:{
            autoplay:{
                delay:3000
            },
            slidesPerView:3,  //展示多少张图片
            slidesPerColumn:2,
            pagination:{
                el:'.swiper-pagination',
                clickable:true
            }
        },
        
     };
    },
    components: {Btns,LoginTabs,swiper,swiperSlide},
    methods: {
        checkAll(){
            this.isAll = !this.isAll
        },
        checkAllJobs(){
            this.$emit('checkCompanyJob')
        },
        gotoMoreJob(){
            this.$router.push({
                // path:`/company/detail?id=${11153}`
                path:`/company/detail`
            })
        },
        goToPosition(id){
            window.open(`/job/detail?id=${id}`);
        }
    }
  };
  </script>
  
  <style lang="scss" scoped>
    $mianColor:#287CF3;
    $whiteColor:#fff;
    $fontCol:rgba(0,0,0,0.85);
    $secondfontCol:rgba(0,0,0,0.5);
    $yellowColor:#FF8A16;
    .main{
       align-items: flex-start;
       .boxShadow{
        background: $whiteColor;
        padding: 24px;
       }
       &-left{
        width: 954px;
        &-title{
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 25px;
          padding-bottom: 16px;
          margin-bottom: 10px;
          border-bottom: 1px solid  #EBEBEB;
        }

        &-companyinfo{
            margin-bottom: 30px;
            max-height: 76px;
            overflow: hidden;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
        }
        &-companyimg{
            margin-bottom: 30px;
            img{
                width: 208px;
                height: 117px;
                margin-bottom: 10px;
                border-radius: 20px;
                overflow: hidden;
                background-color: #287CF3;
                // &:not(:nth-child(4n)){
                //     margin-right: 24px;
                // }
            }
        }
        &-address{
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 30px;
        }
       }
       &-right{
        width: 302px;
        &-title{
            margin-bottom: 20px;
            .btn{
                margin-bottom: 10px;
            }
            p{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 20px;
                padding-bottom: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                span{
                    color: #666666;
                    padding-right: 8px;
                }
            }
            
        }
       }
       .company-desc{
         position: relative;
         .expand{
            position: absolute;
            bottom: 2px;
            right: 0;
            width: 80px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: $mianColor;
            line-height: 20px;
            padding: 4px 0 4px 0;
            transition: font-weight .2s linear;
            text-align: right;
            cursor: pointer;
            background: linear-gradient(270deg,#fff 65%,rgba(255,255,255,0) 100%);
         }
         .noHeight{
            max-height: none;
         }
       }
       .amap-demo {
            width: 100%;
            height: 360px;
        }
        .swiper-pagination-bullets{
            bottom:-4px;
        }
        .swiper-pagination-bullet-active{
            color: #287CF3;
        }
    }
    .hot-job{
        padding: 24px;
        background: $whiteColor;
        margin-bottom: 20px;
        border-radius: 0 0 6px 6px;
        &-title{
            p{
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 25px;
            padding-bottom: 16px;
            }
            .hot-job-all{
                color: $mianColor !important;
                cursor: pointer;
            }
        }
        &-items{
            &-box{
                width: 394px;
                background: $whiteColor;
                border-radius: 6px;
                border: 1px solid #D3D6DB;
                padding: 24px 24px 16px;
                cursor: pointer;
                &:not(:last-child){
                    margin-right: 26px;
                }

                &:hover{
                    box-shadow: 0 16px 40px 0 hsla(0, 0%, 60%, 0.3);
                }
                .flexBetween{
                    flex-wrap: nowrap;
                    width: 100%;
                    p{
                        font-size: 14px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: $fontCol;
                        line-height: 22px; 
                        &:last-child{
                            font-size: 16px;
                            color:  $yellowColor;
                            padding-left: 10px;
                        } 
                    }
                }
            }
            &-bottom{
                border-top: 1px dashed #D9D9D9;
                padding-top: 14px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: $secondfontCol;
                line-height: 17px;
            }
        }
        
    }

  </style>
  